export default "__VITE_ASSET__Yz49p0m5__"